import type { PropsWithChildren } from 'react';
import { Dialog } from 'primereact/dialog';
import classes from './SidePanel.module.scss';

interface SidePanelProps {
    visible: boolean;
    title: string;
    onHide: () => void;
    closable?: boolean;
    id?: string;
    className?: string;
}

/** Открывает боковую панель с удержанием фокуса */
export const SidePanel = (
    { visible, title, onHide, closable = true, id, className, children }: PropsWithChildren<SidePanelProps>
) => (
    <Dialog
        id={id}
        visible={visible}
        header={title}
        onHide={onHide}
        position="right"
        className={[classes.panel, className].filter(Boolean).join(' ')}
        draggable={false}
        resizable={false}
        blockScroll
        dismissableMask={false}
        closable={closable}
        closeOnEscape={closable}
    >
        {children}
    </Dialog>
);
